import React, { Component, Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';
import { push } from 'react-router-redux';
import { connect } from 'react-redux'
import Drawer from '@material-ui/core/Drawer';
import { store } from '../store'
import { Header } from './common/UserCommon';
import SideBar from './common/SideBar';
import agent from '../agent';
import { native, appData, historyManager , onMoveBook, getParameters } from '../utils/common'
import LoadingCircularBar from './common/loadingCircularBar';
import ACTS from '../constants';
import lazy from '../utils/AsyncComponent';
import { MenuIconButton, MenuIconSearchButton, MenuIconCheckboxButton, MenuIconDeleteGroup } from './common/UserIconButton';

// 동적생성
const Setting = lazy(() => import('./pages/setting'))
const MyInfo = lazy(() => import('./pages/myInfo'))
const Asset = lazy(() => import('./pages/asset'))
const Payment = lazy(() => import('./pages/payment'))
const Center = lazy(() => import('./pages/center'))
const Scrap = lazy(() => import('./pages/scrap'))
const Slip = lazy(() => import('./pages/slip'))
const Main = lazy(() => import('./pages/main'))
const Tax = lazy(() => import('./pages/tax'))
const Manage = lazy(() => import('./pages/manage'))
const Debt = lazy(() => import('./pages/debt'))
const Report = lazy(() => import('./pages/report'))

const mapStateToProps = state => { 
    return {
      ...state.common,
      isOpenTopDelete: state.slip.isOpenTopDelete
    }
};
  
const mapDispatchToProps = dispatch => ({
    onLoad: (payload, token) =>
      dispatch({ type: ACTS.APP_LOAD, payload, token }),
    onRedirect: () =>
      dispatch({ type: ACTS.REDIRECT }),
    onOpenTopDelete: status =>
      dispatch({ type: ACTS.OPEN_TOP_DELETE, status }),
    onRunTopDelete: () =>
      dispatch({ type: ACTS.RUN_TOP_DELETE })
});

const NotFound = () => <div>페이지를 찾을수 없습니다.</div>

class App extends Component{
    constructor(props){
      super(props);
      this.state = {
        isOpenSideBar: false,
        userInfo: {
            companyNm: agent.getSessionInfo().companyNm,
            userNm: agent.getSessionInfo().userNm
        } 
      }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.redirectTo) {
            if(nextProps.redirectTo == "/login"){
                window.location.href = "/login";
            }else{
                store.dispatch(push(nextProps.redirectTo));
                this.props.onRedirect();
            }
        } 
    }

    componentWillMount(){
        const { token, isApp } = agent.getSessionInfo();
        
        /*
        let app = isApp ? isApp : getParameters("app");
        
        // 앱에서 구동되지 않은경우(운영)
        if(window.real && !app){
            window.location.href = "/app.html";
            return;
        }*/

        // 앱 접근 정보 기록
        if(getParameters("app")){
           agent.setInfo({app: true});
        }
        
        // 인증에 따른 페이지 이동
        if(!token){
            /*document.addEventListener("deviceready", function(){
            window.plugins.toast.showShortBottom("비로그인")
            })*/
            /*
            if(window.location.pathname === "/consulting"){
                store.dispatch(push('/consulting'));
            }else{*/
                store.dispatch(push('/login'));
            //}
            
        }        
    }  

    // 메뉴 열기
    onClickMenu = status => {
      this.setState({ isOpenSideBar: status });
    }

    initPushInfo = () => {  
        native().loadData();

        // 데이터 조회 콜백
        window.cbQueryKeys = param => {
            if(param.result){ 
                //const uuid = appData('uuid', param.data).get();
                const uuid = window.device.uuid;
                const token = appData('Token', param.data).get();

                agent.Common.updatePushKey(uuid, token);
            }
        }
    }

    onClickDelete = () => {
        this.props.onOpenTopDelete(true);
    }

    onClickTopDelete = () => {
        this.props.onRunTopDelete(false);
    }

    onCancelTopDelete = () => {
        this.props.onOpenTopDelete(false);
    }
    
    render(){
        //console.log(window.device);
        
        return (
            <div className="wrap">
                <LoadingCircularBar />
                <Header>
                    <MenuIconButton onClick={ () => this.onClickMenu(true) } />
                    {
                        window.location.pathname.indexOf("/slip") === 0 ?
                            !this.props.isOpenTopDelete ?
                            <Fragment>
                                { /* <MenuIconSearchButton /> */ }
                                <MenuIconCheckboxButton style={{ right: "38px" }} onClick={ this.onClickDelete } />
                            </Fragment>
                            :                        
                            <MenuIconDeleteGroup onClick={ this.onClickTopDelete } onCancel={ this.onCancelTopDelete } />
                        : ''
                    }

                    <h1><span className="" onClick={ () => onMoveBook('/main') }>{ this.state.userInfo.companyNm }</span></h1>
                </Header>
                <div className="container" style={{ background:"#f4f4f4" }}>

                <Switch>
                    <Route exact path="/slip" component={ Slip } />
                    <Route exact path="/slip/:kind" component={ Slip } />
                    <Route exact path="/slip/:kind/:opt" component={ Slip } />                    
                    <Route exact path="/main" component={ Main } />
                    <Route exact path="/setting/:kind" component={ Setting } />
                    <Route exact path="/myInfo" component={ MyInfo } />
                    <Route exact path="/asset/:kind/:serial" component={ Asset } />
                    <Route exact path="/asset/:kind" component={ Asset } />
                    <Route exact path="/asset" component={ Asset } />
                    <Route exact path="/payment/" component={ Payment } />
                    <Route exact path="/payment/:kind" component={ Payment } />
                    <Route exact path="/center/:kind" component={ Center } />
                    <Route exact path="/scrap" component={ Scrap } />
                    <Route exact path="/report" component={ Report } />
                    <Route exact path="/report/:kind" component={ Report } />
                    <Route exact path="/manage" component={ Manage } />
                    <Route exact path="/manage/:kind" component={ Manage } />
                    <Route exact path="/tax" component={ Tax } />
                    <Route exact path="/tax/:kind" component={ Tax } />
                    <Route exact path="/debt" component={ Debt } />
                    <Route exact path="/debt/:kind" component={ Debt } />
                    <Route component={ NotFound } />    
                </Switch>
                </div>
                <div className="globalFooter"></div>

                <Drawer anchor="left" className="mui-fixed" open={this.state.isOpenSideBar} onClose={ () => this.onClickMenu(false) }>
                    <SideBar user={ this.state.userInfo } onLogout={ ()=>{} } onClose={ ()=> this.onClickMenu(false) } />
                </Drawer >
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js